import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../store/slices/authSlice'
import { useLogoutMutation, authApi } from '../store/api/authApi'
import { schoolAdminApi } from '../store/api/schoolAdminApi'
import { RootState } from '../store'
import toast from 'react-hot-toast'

const Header: React.FC = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state: RootState) => state.auth)
  const [logoutApi] = useLogoutMutation()

  const handleLogout = async () => {
    try {
      await logoutApi().unwrap()
    } catch {
      /* ignore */
    }
    dispatch(logout())
    dispatch(authApi.util.resetApiState())
    dispatch(schoolAdminApi.util.resetApiState())
    toast.success('Logged out')
  }

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-gray-900">Admin Panel</h1>
        <div className="flex items-center space-x-4">
          <span className="text-sm text-gray-600">
            Welcome, {user?.name || 'Admin'}
            {user?.email ? (
              <span className="text-gray-400"> ({user.email})</span>
            ) : null}
          </span>
          <button 
            onClick={handleLogout}
            className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded border border-gray-300 hover:border-gray-400 transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header 